import React from 'react';
import HeroSection from '../components/common/HeroSection';
import FoundationActivities from '../components/foundation/FoundationActivities';

const breadcrumb = [
  { key: 'nav.home',          path: '/' },
  { key: 'nav.ourActivities', path: null },
];

const OurActivities = () => (
  <>
    <HeroSection
      titleKey="activities.title"
      subtitleKey="activities.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <FoundationActivities />
  </>
);

export default OurActivities;
